import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import './newsdetail.scss';
import FooterId from '../../footer/FooterId';
import FooterEn from '../../footer/FooterEn';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FacebookShareButton, WhatsappShareButton, TwitterShareButton } from 'react-share';
import CopyToClipboard from 'react-copy-to-clipboard';
import Twitter from '../../../assets/news/twittericon.png';
import Facebook from '../../../assets/news/facebookicon.png';
import Share from '../../../assets/news/shareicon.png';
import Instagram from '../../../assets/news/instagramicon.png';
import Whatsapp from '../../../assets/news/waicon.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import { format } from 'date-fns';
import id from 'date-fns/locale/id';
import BASE_URL from '../../Util/config';

const NewsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const isIdPath = window.location.pathname.startsWith('/en');
  const [newsData, setNewsData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchNewsDetail = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/api/blog-news/public?type=news`);

        if (response.status === 200 && response.data.success) {
          const items = response.data.data;

          // Cari berita berdasarkan ID
          const selectedNews = items.find((item) => item.id === parseInt(id));

          if (selectedNews) {
            setNewsData(selectedNews);
          } else {
            // Jika tidak ditemukan, redirect ke halaman news
            navigate('/en/news');
          }
        }
      } catch (err) {
        console.log(err);
        navigate('/en/news');
      } finally {
        setLoading(false);
      }
    };

    fetchNewsDetail();
  }, [id, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);

    AOS.init({
      duration: 1300,
    });
  }, []);

  const shareUrl = window.location.href;

  const handleCopyToClipboard = () => {
    setCopied(true);
    toast.success('Link copied to clipboard!', {
      position: 'bottom-center',
      autoClose: 2000,
    });
  };

  const handleInstagramShare = () => {
    const instagramShareUrl = `https://www.instagram.com/?url=${encodeURIComponent(shareUrl)}`;
    window.open(instagramShareUrl, '_blank');
  };

  // Format tanggal
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return format(new Date(dateString), 'EEEE, d MMMM yyyy');
    } catch (error) {
      return '';
    }
  };

  // Dapatkan URL lengkap untuk featured_image
  const getImageUrl = (imagePath) => {
    if (!imagePath) return '';
    // Jika path sudah lengkap (http/https), gunakan langsung
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    // Jika path relatif, tambahkan BASE_URL
    return `${BASE_URL}${imagePath}`;
  };

  return (
    <div className="contentNewsDetail" data-aos="fade-down">
      <div className="newsDetail-content d-flex align-items-center justify-content-center">
        <div className="content-text">
          <h2 className="textHero" data-aos="fade-up">
            NEWS
          </h2>
        </div>
      </div>
      {loading ? (
        <div className="loading-spinner-news">
          <PuffLoader color="#007bff" size={100} margin={2} />
        </div>
      ) : newsData ? (
        <div className="bottomNewsDetail">
          <h1>{newsData.title_en}</h1>

          <div className="shareContent">
            <p>Share the Article</p>
            <div className="shareIcon">
              <WhatsappShareButton url={shareUrl} className="linkIcon">
                <img src={Whatsapp} alt="" className="imgIcon" />
              </WhatsappShareButton>
              <FacebookShareButton url={shareUrl} className="linkIcon">
                <img src={Facebook} alt="" className="imgIcon" />
              </FacebookShareButton>
              <Link className="linkIcon" onClick={handleInstagramShare}>
                <img src={Instagram} alt="" className="imgIcon" />
              </Link>
              <TwitterShareButton url={shareUrl} className="linkIcon">
                <img src={Twitter} alt="" className="imgIcon" />
              </TwitterShareButton>
              <CopyToClipboard text={shareUrl} onCopy={handleCopyToClipboard}>
                <div className="linkIcon" style={{ cursor: 'pointer' }}>
                  <img src={Share} alt="" className="imgIcon" />
                </div>
              </CopyToClipboard>
            </div>

            {/* Tampilkan featured_image */}
            {newsData.featured_image && (
              <div className="featured-image-container">
                <img
                  src={getImageUrl(newsData.featured_image)}
                  alt={newsData.title_id || 'Remala Group'}
                  onError={(e) => {
                    console.error('Error loading image:', newsData.featured_image);
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            )}
          </div>

          {/* Tampilkan content_en */}
          <div className="news-content-body" dangerouslySetInnerHTML={{ __html: newsData.content_en }} />

          {/* Tampilkan tanggal dan penulis */}
          <div className="news-meta">{newsData.written_by && <p className="news-author">Written By : {newsData.written_by}</p>}</div>
        </div>
      ) : null}
      <div className="footer">{isIdPath ? <FooterEn /> : <FooterId />}</div>
    </div>
  );
};

export default NewsDetail;
